export enum TooltipPageId {
    UserPreferences = "user_preferences",
}
